

import { AppProvider, Card, MediaCard } from '@shopify/polaris';
import React, { useState } from 'react'
import PopularAppsCard from '../popular_appscards/popular_apps_cards';

import { install } from '../../../assets/'


interface SponsoredAppsProps {
  mainTitle: string
  sponsoredApps: {
    app_id: string;
    slug: string;
    app_icon: string;
    app_name: string;
    overall_rating: any;
    rating_count: any;
    short_description: string;
    developer_id: string;
    status: string;
    created_at: string;
    updated_at: string;
  }[];
  onAppCardClick: (slug: string,appName:string,appStatus:string,cardSection:string) => void;
}
const SponsoredApps: React.FC<SponsoredAppsProps> = ({ mainTitle, sponsoredApps, onAppCardClick }) => {
  const [showAll, setShowAll] = useState(false);

  const visibleApps = showAll ? sponsoredApps : sponsoredApps.slice(0, 3);

  const handleLoadMore = () => {
    setShowAll(true);
  };

  return (
    <>
      {/* First div - Hide on mobile view */}
  <div className="hidden md:block">
    {/* Content of the first div */}
    <div style={{}}>
        <AppProvider i18n={{}}>

          <div>
            <h1 style={{ color: '#2B1E3E', opacity: "0.65", fontSize: "25px", fontFamily: "sfprobold", wordWrap: 'break-word' }}>{mainTitle}</h1>
          </div>


          <div>
            <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 gap-4' style={{ marginTop: '20px', fontFamily: "sans-serif" }}>
              {visibleApps.map((app, index) => (
                 <div key={index} style={{ position: "relative" }}>
                 {/* Image positioned above the right top of the card */}
                 {app.status === "Installed" && (
                   <img
                     src={install}
                     alt="image"
                     className="absolute top-8 transform -translate-y-1/2 right-[0.9px] z-10"
                     style={{ width: "65px", height: "auto" }}
                   />
                 )}
                  <div className="relative">
                    <PopularAppsCard
                      overallRating={app.overall_rating}
                      reviewsCount={app.rating_count}
                      downloadCount='100k'
                      imageUrl={app.app_icon || 'https://salonlfc.com/wp-content/uploads/2018/01/image-not-found-scaled-1150x647.png'}
                      title={app.app_name}
                      subtitle={app.slug}
                      backgroundColor="white"
                      titleColor="red"
                      reviewColor="black"
                      appDescription={` ${app.short_description}`}
                      subtitleColor='#7E8B9E'
                      onClick={() => onAppCardClick(app.slug,app.app_name,app.status,"sponsored_card")}
                    />
                  </div>
                </div>

              ))}
            </div>
          </div>

          {sponsoredApps.length > 3 && !showAll && (
            <div className="flex justify-center items-center mt-4">
              <button
                onClick={handleLoadMore}
                className="bg-purple-600 border border-transparent rounded-md py-2 px-4 text-white font-semibold text-sm md:text-base lg:text-lg xl:text-xl hover:bg-purple-700 focus:outline-none focus:border-purple-700 focus:ring focus:ring-purple-200 active:bg-purple-800"
              >
                Load More
              </button>
            </div>
          )}

        </AppProvider>
      </div>
  </div>

  {/* Second div - Show on mobile view */}
  <div className="block md:hidden m-5">
    {/* Content of the second div */}
    <div style={{}}>
        <AppProvider i18n={{}}>

          <div>
            <h1 style={{ color: '#2B1E3E', opacity: "0.65", fontSize: "25px", fontFamily: "sfprobold", wordWrap: 'break-word' }}>{mainTitle}</h1>
          </div>


          <div>
            <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 gap-4' style={{ marginTop: '20px', fontFamily: "sans-serif" }}>
              {visibleApps.map((app, index) => (
                <div key={index} style={{ position: "relative" }}>
                {/* Image positioned above the right top of the card */}
                {app.status === "Installed" && (
                  <img
                    src={install}
                    alt="image"
                    className="absolute top-8 transform -translate-y-1/2 right-[0.9px] z-10"
                    style={{ width: "65px", height: "auto" }}
                  />
                )}
                  <div className="relative">
                    <PopularAppsCard
                      overallRating={app.overall_rating}
                      reviewsCount={app.rating_count}
                      downloadCount='100k'
                      imageUrl={app.app_icon || 'https://salonlfc.com/wp-content/uploads/2018/01/image-not-found-scaled-1150x647.png'}
                      title={app.app_name}
                      subtitle={app.slug}
                      backgroundColor="white"
                      titleColor="red"
                      reviewColor="black"
                      appDescription={` ${app.short_description}`}
                      subtitleColor='#7E8B9E'
                      onClick={() => onAppCardClick(app.slug,app.app_name,app.status,"sponsored_card")}
                    />
                  </div>
                </div>

              ))}
            </div>
          </div>

          {sponsoredApps.length > 3 && !showAll && (
            <div className="flex justify-center items-center mt-4">
              <button
                onClick={handleLoadMore}
                className="bg-purple-600 border border-transparent rounded-md py-2 px-4 text-white font-semibold text-sm md:text-base lg:text-lg xl:text-xl hover:bg-purple-700 focus:outline-none focus:border-purple-700 focus:ring focus:ring-purple-200 active:bg-purple-800"
              >
                Load More
              </button>
            </div>
          )}

        </AppProvider>
      </div>
  </div>
    </>
  );

}
export default SponsoredApps

